import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { JobTitleColumns, jobTitleEntityName } from '../../../../backend/config/classifiers';

export function useJobTitleValueProvider(): ValueProvider {
    return buildStorageValueProvider<JobTitleColumns>({
        entityName: jobTitleEntityName,
        label: 'Job Title',
        classifierName: jobTitleEntityName,
        getValues: (client) =>
            client
                .list({
                    filter: [{ column: 'status', op: '=', value: 'active' }],
                    orderBy: [{ column: 'name' }],
                })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name }))),
    });
}
